import { isNil } from './boolean';

const respRegex = /\/resp\/main/;

export function goToResp(path) {
  window.location.href = `/resp${path}`;
}

export function goToStudentServices(path, options) {
  const { type = 'href' } = options || {};

  switch (type) {
    case 'href':
      window.location.href = path;
      break;
    case 'replace':
      window.location.replace(path);
      break;
    default:
      window.location.href = path;
  }
}

export function goToDynamicPath(path = '/', browserHistory, options) {
  if (isNil(path) || typeof path !== 'string') {
    path = '/';
  }

  let { type } = options || {};
  const { pathname: currentPathName = '' } = window?.location || '';

  if (!type && path === currentPathName && respRegex.test(currentPathName)) {
    type = 'reload';
  }

  if (
    (respRegex.test(path) && respRegex.test(currentPathName)) ||
    (!respRegex.test(path) && !respRegex.test(currentPathName))
  ) {
    switch (type) {
      case 'replace':
        return browserHistory.replace(path);
      case 'reload':
        return window.location.reload();
      default:
        return browserHistory.push(path);
    }
  }

  switch (type) {
    case 'replace':
      window.location.replace(path);
      break;
    default:
      window.location.href = path;
  }
}
